package com.example.hukakmp.ui

import androidx.compose.runtime.Composable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.viewinterop.HtmlElementView
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLImageElement

private fun renderReportPhotos(
    container: HTMLDivElement,
    urls: List<String>,
) {
    while (container.firstChild != null) {
        container.removeChild(container.firstChild!!)
    }

    val remoteUrls = urls
        .map { it.trim() }
        .filter { it.startsWith("https://") || it.startsWith("http://") }
        .distinct()

    if (remoteUrls.isEmpty()) {
        val message = document.createElement("div") as HTMLDivElement
        message.textContent = "Las fotos de este parte no están disponibles en la Web."
        message.style.setProperty("font-size", "12px")
        message.style.setProperty("color", "#5C6F78")
        message.style.setProperty("padding", "10px 2px")
        container.appendChild(message)
        return
    }

    remoteUrls.forEachIndexed { index, url ->
        val image = document.createElement("img") as HTMLImageElement
        image.src = url
        image.alt = "Foto del parte " + (index + 1)
        image.style.setProperty("height", "150px")
        image.style.setProperty("min-width", if (remoteUrls.size == 1) "100%" else "210px")
        image.style.setProperty("max-width", if (remoteUrls.size == 1) "100%" else "260px")
        image.style.setProperty("object-fit", "cover")
        image.style.setProperty("border-radius", "14px")
        image.style.setProperty("cursor", "pointer")
        image.style.setProperty("background", "#E8F1F5")
        image.style.setProperty("box-shadow", "0 2px 8px rgba(3, 36, 52, 0.12)")
        image.asDynamic().loading = "lazy"
        image.onclick = {
            window.open(url, "_blank")
            Unit
        }
        container.appendChild(image)
    }
}

@OptIn(ExperimentalComposeUiApi::class)
@Composable
actual fun ReportPhotoGallery(
    urls: List<String>,
    modifier: Modifier,
) {
    HtmlElementView(
        modifier = modifier,
        factory = {
            (document.createElement("div") as HTMLDivElement).apply {
                style.width = "100%"
                style.height = "100%"
                style.display = "flex"
                style.setProperty("gap", "10px")
                style.setProperty("overflow-x", "auto")
                style.setProperty("overflow-y", "hidden")
                style.setProperty("align-items", "stretch")
                style.setProperty("padding", "2px 0 6px 0")
                style.setProperty("box-sizing", "border-box")
                renderReportPhotos(this, urls)
            }
        },
        update = { container ->
            renderReportPhotos(container, urls)
        },
    )
}
